import script from "./survey-svg-2-2.vue?vue&type=script&lang=ts&setup=true"
export * from "./survey-svg-2-2.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__